document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('size-guide-modal');
  const trigger = document.querySelector('.size-guide-trigger');
  const closeBtn = modal ? modal.querySelector('.size-guide-modal__close') : null;
  const overlay = modal ? modal.querySelector('.size-guide-modal__overlay') : null;

  if (!modal || !trigger) return;

  function openModal() {
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
});